import { useNamespace } from '@nio-fe/shared';
import { computed, type PropType } from 'vue';

export const IconPropType = {
  name: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: false,
    default: '',
  },
  spin: {
    type: String as PropType<'cw' | 'ccw'>,
    required: false,
  },
  rotate: {
    type: Number,
    required: false,
  },
  size: {
    type: [String, Number],
    required: false,
    // default: 24,
  },
};

export const useIconThemeColor = new Map([
  ['default', 'var(--n-text-primary)'],
  ['primary', 'var(--n-text-brand-default)'],
  ['info', 'var(--n-text-info-default)'],
  ['success', 'var(--n-text-success-default)'],
  ['warning', 'var(--n-text-warning-default)'],
  ['error', 'var(--n-text-error-default)'],
]);

export function useProps(
  props: {
    name?: string;
    color?: string;
    spin?: string;
    size?: string | number;
    rotate?: number;
  },
  attrs: any,
) {
  const { name, color, spin, size, rotate } = props;
  const prefix = `${useNamespace()}-icon`.toLowerCase();
  const iconClass = `${prefix}_${name}`;
  const spinClassName = spin ? `${prefix}_spin-${spin}` : '';
  const iconStyle = computed(() => ({
    fontSize: `${size}px`,
    transform: `rotate(${rotate}deg)`,
    color: useIconThemeColor.has(color as string) ? useIconThemeColor.get(color as string) : color,
    ...(attrs.style as StyleSheet),
  }));
  return {
    iconClass,
    spinClassName,
    iconStyle,
  };
}
